import moment from "moment";
import type { Story } from "@theirstory/common/api_types/backend";

/**
 * Get display title for a story
 * Returns the story title as-is from the database
 */
export const getStoryDisplayTitle = (story: Story): string =>
  story.title || moment(story.record_date).format("MM/DD/YYYY - h:mm:ss a");
